import { useNavigate, createSearchParams  } from 'react-router-dom';


const usePurchase = () => {
  const navigate = useNavigate();

  const capturePurchaseIntent = (plan: string, cycle: string) => {
    window.localStorage.setItem('purchaseIntent', JSON.stringify({
      plan,
      cycle,
      actioned: false
    }));

    navigate('/dashboard/billing');
  };


  const actionPurchaseIntent = () => {
    const raw = window.localStorage.getItem('purchaseIntent');
    if (!raw) return;

    try {
      const intent = JSON.parse(raw);
      window.localStorage.removeItem('purchaseIntent');

      navigate({
        pathname: '/dashboard/billing',
        search: createSearchParams({
          plan: intent.plan,
          cycle: intent.cycle,
        }).toString(),
      });
    } catch {
      window.localStorage.removeItem('purchaseIntent');
    }
  }

  return { capturePurchaseIntent, actionPurchaseIntent };
};

export default usePurchase;
